import { useStyles } from "./styles";
import { StatusCartEnum } from "@/main/services/enum/StatusCartEnum";
import { getTranslateByKey } from "@/main/services/utils";

interface Props {
	status: number;
}

export const renderColor = (status: number) => {
	switch (status) {
		case StatusCartEnum.Pending:
			return "#ff9900";
		case StatusCartEnum.Answered:
			return "#00cc66";
		default:
			return "#00cc66";
	}
};

export default function StatusCartComponent(props: Props) {
	const classes = useStyles();

	const renderName = () => {
		switch (props.status) {
			case StatusCartEnum.Pending:
				return getTranslateByKey("quotesuppitemstatus.pending");
			case StatusCartEnum.Answered:
				return getTranslateByKey("quotesuppitemstatus.answered");
		}
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={renderName()}
			style={{ backgroundColor: renderColor(props.status) }}
		>
			<span className={classes.spanContainer}>{renderName()}</span>
		</div>
	);
}
